import Vue from "vue";

const CONFIG_API = {
    productList:"/pc/index/theme",
    filter:'/pc/index/theme-condition',
}

export function getGoods(data){
    return Vue.$axios.$post(CONFIG_API.productList, { data })
}

export function getFilter(data){
    return Vue.$axios.$post(CONFIG_API.filter, { data })
}
